import config from '~/config';

export default function parseUrlCurrency(
	currency: string | (string | null)[] | null = config.product.defaultPriceCurrency
): string | null {
	return currency !== 'any' && typeof currency === 'string' && currency.match(/^[A-Z]{3}$/) !== null ? currency : null;
}
